export default "__VITE_ASSET__9uL8yWRa__"